import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import Client from "models/client";
import { ClientEngagement } from "models/client-engagement";
import Employee from "models/employee";
import Opportunity from "models/opportunity";

export interface ClientEngagementSliceState {
    clientEngagements: ClientEngagement[],
    clientEngagementCount: number,
    employees: Employee[],
    opportunities: Opportunity[],
    clients: Client[]
}

export const initialState: ClientEngagementSliceState = {
    clientEngagements: [],
    clientEngagementCount: 0,
    employees: [],
    opportunities: [],
    clients: []
};

const ClientEngagementSliceState = createSlice({
    name: "clientEngagement-slice",
    initialState,
    reducers: {
        setClientEngagements(state, { payload }: PayloadAction<ClientEngagement[]>) {
            state.clientEngagements = payload
        },
        setClientEngagementCount(state, { payload }: PayloadAction<number>) {
            state.clientEngagementCount = payload
        },
        setClientEngagement(state, { payload }: PayloadAction<{
            clientEngagement: ClientEngagement,
            index: number
        }>) {
            state.clientEngagements[payload.index] = payload.clientEngagement
        },
        setClientEngagementSearchFields(state, { payload }: PayloadAction<{
            employees: Employee[],
            opportunities: Opportunity[],
            clients: Client[]
        }>) {
            state.employees = payload.employees;
            state.opportunities = payload.opportunities;
            state.clients = payload.clients
        },
        deleteClientEnagement(state, { payload: clientEngagementId }: PayloadAction<string>) {
            state.clientEngagements = state.clientEngagements.filter(r => r.id !== clientEngagementId);
            state.clientEngagementCount = state.clientEngagementCount - 1
        },
        addClientEngagement(state, { payload }: PayloadAction<ClientEngagement>) {
            state.clientEngagements = [payload, ...state.clientEngagements];
        }
    },
});

export const {
    setClientEngagement,
    setClientEngagements,
    setClientEngagementCount,
    deleteClientEnagement,
    setClientEngagementSearchFields,
    addClientEngagement
} = ClientEngagementSliceState.actions

export default ClientEngagementSliceState.reducer;
